module.exports = __webpack_public_path__ + "img/img48.f6b4cff4.svg";